export * from './promotion-page';
